import React, {VoidFunctionComponent} from "react";

export const BottomLayout: VoidFunctionComponent<{ children?: JSX.Element }> = ({children}) => {
    if (!children) {
        return null;
    }
    return <div className="layer-bottom">{children}</div>;
};